import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
const heroPattern = "/images/hero-pattern.webp";
import { AssistentBanner } from "@/components/AssistentBanner";
import { HeroDashboardMockup } from "@/components/sections/HeroDashboardMockup";
import { TrustindexWidget } from "@/components/TrustindexWidget";
import { BrandMark } from "@/components/BrandMark";
const usps = ["Persoonlijk contact", "Vaste prijzen", "Alles onder één dak"];


export function Hero() {
  return <section aria-labelledby="hero-heading" className="relative min-h-[calc(100vh-80px)] flex items-center overflow-x-clip overflow-y-visible">
      {/* Background pattern */}
      <div className="absolute inset-0">
        <img 
          src={heroPattern} 
          alt="" 
          aria-hidden="true"
          fetchPriority="high"
          decoding="sync"
          className="w-full h-full object-cover opacity-30"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-background/80" />

      {/* Subtiel zwevend beeldmerk — alleen op kleinere viewports zichtbaar zodat mockup op desktop intact blijft */}
      <div className="xl:hidden absolute top-6 right-4 sm:right-8 z-0 opacity-25 pointer-events-none">
        <BrandMark size={88} variant="float" />
      </div>


      
      <div className="container-wide relative w-full">
        <div className="xl:max-w-[60%] 2xl:max-w-[58%]">
          <div className="relative z-10">
            <h1 id="hero-heading">
              Alles voor je website.<br />
              <span className="text-muted-foreground">Eén aanspreekpunt.</span>
            </h1>
            
            <p className="mt-8 text-lead max-w-xl">
              Ik regel alles rondom je website, webshop en online vindbaarheid. 
              Zodat jij je kunt focussen op waar je goed in bent.
            </p>
            
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Button asChild variant="default" size="xl">
                <Link to="/kennismaking">
                  Plan een gesprek
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="hero-outline" size="xl">
                <a href="tel:+31592887788">
                  Bel direct: 0592 88 77 88
                </a>
              </Button>
            </div>

            <div className="mt-5">
              <AssistentBanner variant="inline" />
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2">
              {usps.map((usp) => <div key={usp} className="flex items-center gap-2">
                  <Check className="h-4 w-4 text-accent flex-shrink-0" />
                  <span className="text-sm text-muted-foreground">{usp}</span>
                </div>)}
            </div>

            <div className="mt-6">
              <TrustindexWidget loaderId="326cc16641b2405ed5265209433" eager />
            </div>
          </div>
        </div>
      </div>

      {/* Mockup – absolutely positioned right, vertically centered */}
      <div className="hidden xl:block absolute right-[-2vw] 2xl:right-0 top-1/2 -translate-y-1/2 z-0 pointer-events-none w-[42%] 2xl:w-[40%]">
        <HeroDashboardMockup />
      </div>
    </section>;
}